module.exports = __webpack_public_path__ + "static/img/62.393058a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/62.png
// module id = oCHR
// module chunks = 1